module.exports = __webpack_public_path__ + "static/media/ML.a9ffdece.png";